import { nextTick, onBeforeUnmount, onMounted } from 'vue';
/**
 * Focuses an element when a single key is pressed while nothing else is focused
 * (e.g. the "/" search shortcut). The handler is a no-op when the user is
 * already typing in an input/textarea/editable, so the key still types normally.
 *
 * Registers a `keydown` listener on `window` for the component's lifetime.
 *
 * @param key      Key to react to (matched against `KeyboardEvent.key`, e.g. '/').
 * @param target   Ref to the element to focus.
 * @param onFocus  Optional callback fired after the element is focused.
 */
export function useFocusHotkey(key, target, onFocus) {
    function onKeydown(event) {
        if (event.key !== key)
            return;
        const active = document.activeElement;
        const nothingFocused = active === document.body || active === document.documentElement;
        if (!nothingFocused || !target.value)
            return;
        event.preventDefault();
        nextTick(() => {
            target.value?.focus();
            onFocus?.();
        });
    }
    onMounted(() => window.addEventListener('keydown', onKeydown));
    onBeforeUnmount(() => window.removeEventListener('keydown', onKeydown));
}
